import { CurrentNavi } from './controller';
import './styles.css';

const SELECTOR = '.section, .sub-section';
let initialized = false;
let currentNaviInstance: CurrentNavi | null = null;

export function initCurrentNavi(): void {
    if (initialized) return;
    initialized = true;
    document.addEventListener('ui:update', () => mount(document));
    document.addEventListener('ui:update', () => mountProgressBar(), { once: true });
}

function mount(_scope: ParentNode): void {
    currentNaviInstance?.destroy();
    currentNaviInstance = null;
    const naviWrapper = document.querySelector<HTMLElement>('.current-navi');
    if (naviWrapper) naviWrapper.innerHTML = '';
    currentNaviInstance = new CurrentNavi(SELECTOR, {
        showLabels: 'active',
    });
}

function mountProgressBar(): void {
    const bar = document.querySelector<HTMLElement>('.page-progress');
    if (!bar) return;

    const update = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
        document.documentElement.style.setProperty('--scroll-progress', `${pct}%`);
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
}